export const getCombinedPageVariables = ({
  pageVariables,
  pageVariablesMethods,
}: {
  pageVariables: Record<string, unknown>;
  pageVariablesMethods: Record<string, unknown>;
}) => {
  const combinedPageVariables: Record<string, unknown> = {};
  const keys = Object.keys(pageVariables);
  const keysLength = keys.length;

  for (let i = 0; i < keysLength; i++) {
    const key = keys[i];
    combinedPageVariables[key] = {
      value: pageVariables[key],
      ...(pageVariablesMethods[key] as Record<string, unknown>),
    };
  }

  return combinedPageVariables;
};
